export default __webpack_public_path__ + "43f28cf151a0ec8cd20ffa330e48d8b584930854db833b4f8808fef95fa16124.svg";